module.exports = __webpack_public_path__ + "static/media/map stop icon.e661e62e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/map stop icon.svg
// module id = 894
// module chunks = 0